import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue';
import Vuex from 'vuex';
import VueSweetAlert2 from 'vue-sweetalert2';
import App from './components/App.vue';
import store from './store';
import Roles from './mixins/Roles.vue';
import axios from './plugins/axios';
import Permissions from './mixins/Permissions.vue';
import vuetify from '../plugins/vuetify';
import 'vuetify/dist/vuetify.min.css'
import router from './routes';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'leaflet/dist/leaflet.css';
import {Icon} from 'leaflet';
import {TiptapVuetifyPlugin} from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
import JsonExcel from "vue-json-excel";

const options = {
    confirmButtonColor: '#2277F0',
};

Vue.use(vuetify);
Vue.use(Vuex);
Vue.use(VueSweetAlert2, options);
Vue.use(TiptapVuetifyPlugin, {
    vuetify,
    iconsGroup: 'mdi'
});
Vue.mixin(Roles);
Vue.mixin(Permissions);

Vue.component("downloadExcel", JsonExcel);

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

window.axios = axios;

new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store,
    vuetify: vuetify,
    components: {
        App,
    },
    watch: {
        $route: {
            async handler() {
                if (this.$route.meta.requiresAuth) {
                    await this.$store.dispatch('auth/fetchUser');
                    await this.$store.dispatch('auth/fetchAbilities');
                }
            }
        },
        immediate: true
    }
})
